// extracted by css-extract-rspack-plugin
export default {"form":"form-F1xJtN","fields":"fields-ynCEW7","inputRow":"inputRow-xz33np","numberField":"numberField-j0bS8Z","errorList":"errorList-oDfOYW"};